import { sumValues, sumDistinctProjs } from './p2pSvc';

export const getTotalData = (renderData, years, fundings) => {
  const withBasePart = !fundings || fundings.includes('base');
  const withSpecialPart = !fundings || fundings.includes('special');

  return years.reduce((acc, year) => {
    const planTotalB = withBasePart ? sumValues(renderData, `plan${year}B`) : 0;
    const planTotalS = withSpecialPart ? sumValues(renderData, `plan${year}S`) : 0;
    const planTotalAll = planTotalB + planTotalS;

    const planApprovedTotalB = withBasePart ? sumDistinctProjs(renderData, `planApproved${year}B`) : 0;
    const planApprovedTotalS = withSpecialPart ? sumDistinctProjs(renderData, `planApproved${year}S`) : 0;
    // поскольку в ЦП разрешено заводить планы по бюджету разных типов (спец.ч., баз.ч.) в одном году,
    // для получения итогового количества необходимо собрать уникальные значения id проектов из обоих столбцов соответствующего типа
    const planApprovedTotalAll = sumDistinctProjs(renderData, withBasePart ? `planApproved${year}B` : '', withSpecialPart ? `planApproved${year}S` : '');

    const factTotalB = withBasePart ? sumDistinctProjs(renderData, `fact${year}B`) : 0;
    const factTotalS = withSpecialPart ? sumDistinctProjs(renderData, `fact${year}S`) : 0;
    const factTotalAll = sumDistinctProjs(renderData, withBasePart ? `fact${year}B` : '', withSpecialPart ? `fact${year}S` : '');

    return {
      ...acc,
      [`plan${year}TotalB`]: {value: planTotalB},
      [`plan${year}TotalS`]: {value: planTotalS},
      [`plan${year}TotalAll`]: {value: planTotalAll},
      [`plan${year}ApprovedTotalB`]: {value: planApprovedTotalB},
      [`plan${year}ApprovedTotalS`]: {value: planApprovedTotalS},
      [`plan${year}ApprovedTotalAll`]: {value: planApprovedTotalAll},
      [`fact${year}TotalB`]: {value: factTotalB},
      [`fact${year}TotalS`]: {value: factTotalS},
      [`fact${year}TotalAll`]: {value: factTotalAll},
    };
  }, {});
};
